import { ERoleAccess, EAdminAccessStatus } from '@/enum';
import useUser from '@/store/useUser';

export const useAccess = () => {
  const { user } = useUser();

  const isFullAccess = user?.is_access === EAdminAccessStatus.FULL_ACCESS;

  const hasAccess = (sectionName: ERoleAccess) => {
    // Check if the section exists in the user's sections array
    const section = user?.sections?.find(
      (sec) => sec.section_code === sectionName
    );

    // If the section is explicitly defined, return its access status
    if (section) {
      return !!section.has_access;
    }

    // Fallback to global access level if section is not explicitly defined
    return isFullAccess;
  };

  return { hasAccess, isFullAccess };
};

export default useAccess;
